import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  tableHolder: {
    maxWidth: 'calc(100vw - 8rem)',

    [theme.breakpoints.down('md')]: {
      maxWidth: 'calc(100vw - 1rem)'
    },

    '& .table-root': {
      minHeight: ({ loaded }) => (loaded ? 'unset' : '10rem')
    },

    '& .bottomRow': {
      '& .children': {
        width: '100%'
      }
    }
  },

  table: {
    '& > div': {
      marginBottom: ({ smallMedia }) => (smallMedia ? '1rem' : '2rem'),

      '&:last-child': {
        marginBottom: ({ smallMedia }) => (smallMedia ? '0' : '0.5rem')
      }
    },

    '& .table-root': {
      minHeight: ({ loaded }) => (loaded ? 'unset' : '10rem')
    }
  }
}))

export default useStyles
